import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=4987eb62&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=ts"
export * from "./MobileSidebar.vue?vue&type=script&lang=ts"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&id=4987eb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987eb62",
  null
  
)

export default component.exports